/**
 * @fileoverview DELETE handler for the "/alloys/partners/datadog/:app_group_id" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryMutationAdapter } from "../reactQueryFetcherAdapters";
import { deleteAlloysPartnersDatadogAppGroupIdCacheKeys } from "./constants";
import type {
  DeleteAlloysPartnersDatadogAppGroupIdProps,
  DeleteAlloysPartnersDatadogAppGroupIdResult,
} from "./types";

export const deleteAlloysPartnersDatadogAppGroupId = reactQueryMutationAdapter(
  deleteAlloysPartnersDatadogAppGroupIdCacheKeys,
  (props: DeleteAlloysPartnersDatadogAppGroupIdProps): Promise<DeleteAlloysPartnersDatadogAppGroupIdResult> => {
    return fetch(`/alloys/partners/datadog/${props.appGroupId}`, "DELETE", {}, undefined, {
      propagateFetchRequestError: false,
    });
  }
);
